import { BaseModel } from '../base.model';
import { required } from '../json-map.util';

class LessonRequest {
}

namespace LessonRequest {


  export class Create extends BaseModel {
    @required()
    courseId: number = undefined;
    @required()
    title: string = undefined;

    strategyLessonEnabled: number = undefined;
    smartSaversEnabled: number = undefined;
    showCorrectEnabled: number = undefined;
    showMetricsEnabled: number = undefined;
    openAnswerOnComplete: number = undefined;

    description: string = undefined;
  }

  export class Update extends Create {
    exerciseIds: number[] = undefined;
  }

}

export { LessonRequest };

